import client from './client';

export async function login(email, password) {
  const { data } = await client.post('/auth/login', { email, password });
  return data;
}

export async function refresh() {
  const { data } = await client.post('/auth/refresh', {});
  return data;
}

export async function logout() {
  const { data } = await client.post('/auth/logout', {});
  return data;
}

export async function me() {
  const { data } = await client.get('/auth/me');
  return data;
}

export async function register(payload) {
  const { data } = await client.post('/auth/register', payload);
  return data;
}

export async function updateProfile(payload) {
  const { data } = await client.patch('/auth/me', payload);
  return data;
}

export async function verifyEmail(token) {
  const { data } = await client.post('/auth/verify-email', { token });
  return data;
}

export async function resendVerification(email) {
  const { data } = await client.post('/auth/resend-verification', { email });
  return data;
}

export async function deactivateAccount(payload) {
  const { data } = await client.post('/auth/deactivate', payload);
  return data;
}

export async function exportMyData() {
  const { data } = await client.get('/auth/me/export');
  return data;
}
